import type { ComponentSchema } from "../../../../../schema-types";
import { SECTION_STYLE_FIELDS } from "../../_builder-constants";

export const schema: ComponentSchema = {
  type: "compare",
  label: "Product Comparison",
  description: "Up to 4 pieces side by side under arched portrait photos: price with the saving and the best price marked, fabric, colour swatches, size, work and other attributes, category and brand, with \"Show differences only\", add to bag, remove, and \"Ask on WhatsApp\" when the store has a WhatsApp number.",
  supportedPages: ["compare"],
  variants: [
    {
      id: "v1",
      label: "Table",
    },
  ],
  commonFields: [...SECTION_STYLE_FIELDS],
};
